import { useEffect, useRef } from 'react';
import Header from './Header.js';
import ViewportTracker from './ViewportTracker.js';
import VicktoriaPromoVideo from './assets/Promo_Video_v2.mp4';
import WaitlistButton from './WaitlistButton.js';
import { PAGE_MAX_WIDTH, PAGE_CONTAINER_MARK } from './layout.js';
//team photo imports
import Andrey from './assets/About Us Images/Team Photos/Andrey.jpeg';
import Chasity from './assets/About Us Images/Team Photos/chasity.png';
import David from './assets/About Us Images/Team Photos/David.jpg';
import Jay from './assets/About Us Images/Team Photos/Jay.jpeg';
//import Disha from './assets/About Us Images/Team Photos/Disha.jpg';
import Leia from './assets/About Us Images/Team Photos/Leia Dog Photo.jpg';
//board photo imports
import Tom from './assets/About Us Images/Board Photos/Tom.jpeg';
// FOLLOW-UP (2026-09-26): David Weiss removed from the Advisory Board. The
// photo (Board Photos/David_Weiss.jpeg) is intentionally kept in assets for
// now — decide later whether to delete it or restore Weiss to the board.
//import David_W from './assets/About Us Images/Board Photos/David_Weiss.jpeg';
import Jay_S from './assets/About Us Images/Board Photos/Jay_S.png';

// Source-of-truth content for the Founder's Story bubble. Exported so
// AboutUs.test.js can pin the required companies, awards, boards, and
// dates against silent edits. Rendering lives in BubbleSection.
export const FOUNDER_STORY_HEADING = "Our Founder's Story";

export const FOUNDER_STORY_PARAGRAPHS = [
  'Andrey V. Karpov has created impact through servant leadership and Agile transformation at large companies like Citibank, Bank of America, JPMorgan Chase, Capital One, Winvale, Flashpoint, Apple, Kroger Technology, Indivior Pharma, Nagarro, as well as at U.S. General Services Administration and U.S. Defense Logistics Agency through government contracting.',
  'Andrey is a Wall Street Journal Achievement Award graduate from New York Institute of Technology with B.S. in International Business Administration and minor in Computer Graphics. He is an Alumni Mentor at NYIT and a supporter of his alma-mater.',
  'Andrey has also served/continues to serve as a Strategic Advisor on many nonprofit boards bringing transformation trough servant leadership at IT4Causes, Project Management Institute Central Virginia Chapter, Metropolitan Business League, National Speakers Association of Virginia, Toastmasters International, Virginia Association of Fundraising Executives, Commonwealth Agency Agile Conference, ECPI University Software Development Advisory Board, New York Tech School of Management, CodeRVA Regional High School, and Career Prospectors.',
  'Andrey has been a guest speaker and presenter on many TV, radio, and podcasting stations like CBS6, ESPN Business Radio, The Work FM Radio, Ignite - Sparked by Better Business Bureau Podcast, Good Eye Podcast, Throttle Up Leadership Podcast, as well as Agile in Nonprofits Online Summit to name a few prominent ones.',
  'Since 2019, this has led to the foundation and formulation of TrueAgileMindset℠ coaching and consulting methodology that focuses on people and the evolution of human thought and creativity through the use of modern complex technology, including AI.',
  'Since 2025, Andrey has been building the Vicktoria AI™ brand that focuses on building humanlike ethical AI models that integrate TrueAgileMindset℠ through companions like Vicka AI™ and the legacy-preservation Memorandum Project™ (coming in 2027).',
];

// Core team members rendered in the TeamBubble grid. Exported so
// AboutUs.test.js can pin titles + the optional `italicSubline` field
// (e.g. David's "US Navy Veteran" line) against silent content edits.
// `sublineLink`, when present, hyperlinks the italic subline.
export const CORE_TEAM_MEMBERS = [
  { name: "Andrey V. Karpov, BSBA, CSM/CSPO", role: "Founder, President, Executive Chairman of the Board, & CEO", img: Andrey, linkedin: "https://www.linkedin.com/in/andreyvkarpov/" },
  { name: "David Cowart, MBA/PMP", role: "Chief Technology & Information Officer", italicSubline: "US Navy Veteran", sublineLink: "https://www.navy.com/", img: David, linkedin: "https://www.linkedin.com/in/david-cowart-9a884236/" },
  { name: "Jay Daftari, MSCE", role: "Head of Software Development & Machine Learning", img: Jay, linkedin: "https://www.linkedin.com/in/jay-daftari/" },
  { name: "Chasity L. Bailey, J.D.", role: "GRC and Legal Counsel", italicSubline: "Toastmasters International", sublineLink: "https://www.toastmasters.org/", img: Chasity, linkedin: "https://www.linkedin.com/in/chasitylbailey/" },
  // No personal LinkedIn. Her name links to Instagram via `nameLink` (not
  // `linkedin` — that field name is reserved for actual LinkedIn URLs), and
  // her affiliation line names the Richmond SPCA via `sublineLink`.
  { name: "Princess Leia", role: "Chief Barking Security Officer", nameLink: "https://www.instagram.com/the_princess_leia_dog/", italicSubline: "Richmond SPCA", sublineLink: "https://richmondspca.org/", img: Leia },
];

// Advisory board members rendered in the BoardBubble grid (2026-09-11 —
// Stephen Spiro removed, board reduced to 3 members; 2026-09-26 — David Weiss
// removed, board reduced to 2 members). Each `role` is italic-script unicode;
// `org` is the plain-text organization line rendered beneath it, hyperlinked
// to `orgLink`. Exported so the test file can pin each advisor's title, org,
// and order.
export const ADVISORY_BOARD_MEMBERS = [
  { name: "Tom Loker", role: "𝘈𝘐 𝘓𝘓𝘔 𝘌𝘯𝘨𝘪𝘯𝘦𝘦𝘳𝘪𝘯𝘨, 𝘋𝘢𝘵𝘢 𝘚𝘤𝘪𝘦𝘯𝘤𝘦, & 𝘊𝘺𝘣𝘦𝘳𝘴𝘦𝘤𝘶𝘳𝘪𝘵𝘺 𝘈𝘥𝘷𝘪𝘴𝘰𝘳", org: "Individual Centricity Corp.", orgLink: "https://individualcentricity.com/", img: Tom, linkedin: "https://www.linkedin.com/in/thomaswloker/" },
  { name: "Jay Snider", role: "𝘏𝘶𝘮𝘢𝘯 𝘊𝘢𝘱𝘪𝘵𝘢𝘭 𝘚𝘵𝘳𝘢𝘵𝘦𝘨𝘺 & 𝘍𝘶𝘯𝘥𝘳𝘢𝘪𝘴𝘪𝘯𝘨 𝘈𝘥𝘷𝘪𝘴𝘰𝘳", org: "Amalgamate Partners LLC", orgLink: "https://www.amalgamatepartners.net/", img: Jay_S, linkedin: "https://www.linkedin.com/in/jaysnider/" },
];


// Renders ℠/™ marks as true superscript wherever they appear in a string,
// without altering the underlying content strings (FOUNDER_STORY_PARAGRAPHS
// stays plain text for the test file's toContain/toMatch assertions).
const withTrademarkMarks = (text) =>
  text
    .split(/(℠|™)/)
    .map((part, i) => (part === '℠' || part === '™' ? <sup key={i}>{part}</sup> : part));

const BubbleSection = () => {

  // 1. Defined a reusable style object for the bubbles to keep code clean
  const bubbleContainerStyle = {
    backgroundColor: '#81B2CA',
    padding: 'clamp(20px, 4vw, 40px)', // Padding shrinks slightly on mobile
    borderRadius: '30px',
    // Fills the shared page column below (no independent vw-based cap) so its
    // edges line up with the Header nav bar and every other page's sections.
    width: '100%',
    boxSizing: 'border-box',
    textAlign: 'center',
    boxShadow: '0 4px 6px rgba(0,0,0,0.1)' // Optional: Adds subtle depth like the image
  };

  // 2. Defined a reusable style for the text content
  const textContentStyle = {
    fontFamily: 'Inter, sans-serif',
    fontSize: 'clamp(16px, 1.2vw, 19px)', // CLAMP: Font scales between 16px and 19px
    lineHeight: '1.6',
    textAlign: 'left',
    color: '#000000',
    maxWidth: '100%',
    margin: '0 auto',
  };

  // Helper for headings inside the bubbles
  const headingStyle = {
    fontSize: 'clamp(20px, 2vw, 24px)',
    marginBottom: '10px',
    display: 'block',
    fontWeight: 'bold'
  };

  return (
    <section style={{
      backgroundColor: '#D1DEE6',
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
    }}>
      {/* LAYER 2: The Vertical Stack Container */}
      <div data-layout={PAGE_CONTAINER_MARK} style={{
        width: '100%',
        maxWidth: PAGE_MAX_WIDTH,
        margin: '0 auto',
        padding: '0 5%', // Header now owns the 40px gap below it; this section starts flush.
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column', // Stacks items vertically
        gap: '30px',              // Space between the bubbles
        alignItems: 'center'      // Centers bubbles horizontally
      }}>

        {/* --- BUBBLE 1: Vicktoria Intro --- */}
        <div style={bubbleContainerStyle}>
          <div style={textContentStyle}>
            <span style={headingStyle}>Vicktoria AI™ Companion (aka Vicka)</span>
            <p>
              The first humanlike ethical AI companion system to logically disagree with you but tell you why,
              challenging your critical thinking and making you an advanced person for the sake of humanity's
              intellectual preservation to build legacy beyond.
            </p>
          </div>
        </div>

        {/* --- BUBBLE 2: TrueAgileMindset℠ --- */}
        <div style={bubbleContainerStyle}>
          <div style={textContentStyle}>
            <span style={headingStyle}>{withTrademarkMarks('TrueAgileMindset℠ Framework')}</span>
            <p>
              {withTrademarkMarks(
                'TrueAgileMindset℠, founded in 2019 by our CEO Andrey V. Karpov, is a proprietary ' +
                'decentralized coaching and consulting framework that leverages fundamental Agile ' +
                'principles, Ikigai matrix, Human Design, classical philosophy, modern psychology, ' +
                'and other neuroscience disciplines all combined to serve as an ethical and ' +
                'constantly evolving humanistic framework and governance protocol in Web3 and ' +
                'Blockchain space, empowering individuals and decentralized autonomous organizations ' +
                '(DAOs) through trustless, yet emotionally intelligent interactions creating a new ' +
                'AI protocol for human and system communications through a breakthrough approach of ' +
                'building LLMs Ethical by Design™ (EbyD™) and Ethical as Service™ (EasS™).'
              )}
            </p>
          </div>
        </div>

        {/* --- BUBBLE 3: Mission, Philosophy, Vision --- */}
        <div style={bubbleContainerStyle}>
          <div style={textContentStyle}>

            <div style={{ marginBottom: '25px' }}>
              <span style={headingStyle}>Mission</span>
              <p style={{ marginTop: '5px' }}>
                To preserve human presence, emotion, and legacy through humanlike ethical AI companions by
                creating emotionally intelligent virtual replicas that empower aging individuals to connect
                across time, space, and memory with their loved ones.
              </p>
            </div>

            <div style={{ marginBottom: '25px' }}>
              <span style={headingStyle}>Philosophy</span>
              <p style={{ marginTop: '5px' }}>
                We believe that True Agility is rooted in empathy, not just efficiency. Our framework combines
                neuroscience, ethics, civic responsibility, and emotional intelligence to create AI that feels,
                remembers, and honors the human experience. We are building not just artificial intelligence,
                but artificial legacy of real humans that want to create generational digital wealth.
              </p>
            </div>

            <div>
              <span style={headingStyle}>Vision</span>
              <p style={{ marginTop: '5px' }}>
                To become the world's most trusted human-centered AI platform for end-of-life legacy,
                emotional companionship, and ethical post-human interaction - bridging the gap between
                memory and presence, between life and legacy.
              </p>
            </div>

          </div>
        </div>

        {/* --- BUBBLE 4: Our Founder's Story --- */}
        <div style={bubbleContainerStyle}>
          <div style={textContentStyle}>
            <span style={headingStyle}>{FOUNDER_STORY_HEADING}</span>
            {FOUNDER_STORY_PARAGRAPHS.map((text, i) => (
              <p
                key={i}
                style={{
                  marginTop: i === 0 ? '5px' : '0',
                  marginBottom: i === FOUNDER_STORY_PARAGRAPHS.length - 1 ? '0' : '20px',
                }}
              >
                {withTrademarkMarks(text)}
              </p>
            ))}
          </div>
        </div>

      </div>
    </section>
  )
}

const TeamBubble = () => {
  // 1. Grid Logic:
  // We use a specific class "team-grid" to handle the exact breakpoint at 800px.
  // This ensures it is ALWAYS 2 columns on mobile/tablets, and 4 on desktop.
  // Flexbox with fixed 4-column card widths (same math as BoardBubble) rather
  // than CSS Grid, so an under-full last row (e.g. 5 members) centers instead
  // of hugging the left edge.
  const css = `
    .team-grid {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      gap: 30px; /* Space between photos */
      width: 100%;
    }
    .team-grid > * {
      flex: 0 0 calc((100% - 90px) / 4);
      max-width: calc((100% - 90px) / 4);
    }

    /* The Breakpoint: Below 800px width, force 2 columns */
    @media (max-width: 800px) {
      .team-grid > * {
        flex-basis: calc((100% - 30px) / 2);
        max-width: calc((100% - 30px) / 2);
      }
    }
  `;

  const teamMembers = CORE_TEAM_MEMBERS;

  return (
    <section style={{
      backgroundColor: '#D1DEE6',
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      padding: '40px 0'
    }}>
      {/* Inject CSS for the Grid */}
      <style>{css}</style>

      {/* Shared page column so this panel's edges line up with the Header
          nav bar and every other section on the site. */}
      <div data-layout={PAGE_CONTAINER_MARK} style={{ width: '100%', maxWidth: PAGE_MAX_WIDTH, margin: '0 auto', padding: '0 5%', boxSizing: 'border-box' }}>
      {/* The Lighter Blue Bubble (#B3CFDB) */}
      <div style={{
        backgroundColor: '#B3CFDB', // Lighter blue as requested
        borderRadius: '30px',
        padding: 'clamp(20px, 4vw, 50px)',
        width: '100%',
        boxSizing: 'border-box',
        boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }}>

        {/* Title */}
        <h2 style={{
          fontFamily: 'Inter, sans-serif',
          fontSize: 'clamp(32px, 4vw, 42px)',
          marginBottom: '40px',
          marginTop: '0',
          color: '#000000',
          fontWeight: '400'
        }}>
          Core Team
        </h2>

        {/* The Grid Container */}
        <div className="team-grid">
          {teamMembers.map((member, index) => (

            /* Individual Team Card */
            <div key={index} style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start', // Left align text like the image
              textAlign: 'left'
            }}>

              {/* Photo */}
              <img
                src={member.img}
                alt={member.name}
                style={{
                  width: '100%',
                  aspectRatio: '1 / 1', // Keeps images perfectly square
                  objectFit: 'cover',
                  borderRadius: '16px', // Slight rounding on photos
                  marginBottom: '10px',
                  backgroundColor: '#ccc',
                  boxShadow: '0 12px 6px rgba(0,0,0,0.1)',
                  // --- ADD THESE LINES ---
                  border: '4px solid #0056b3', // Adjust thickness (4px) and color (#0056b3) as you like
                  borderRadius: '20px',        // Matches the curve in your example
                  boxSizing: 'border-box',      // Keeps the image size from expanding
                  // -----------------------

                }}
              />

              {/* Name */}
              <a
                href={member.linkedin || member.nameLink}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  fontFamily: 'Inter, sans-serif',
                  fontWeight: 'bold',
                  fontSize: 'clamp(14px, 1.5vw, 16px)',
                  color: '#000000',
                  marginBottom: '4px',
                  textDecoration: 'underline',
                  cursor: 'pointer'
                }}
              >
                {member.name}
              </a>

              {/* Role */}
              <div style={{
                fontFamily: 'Inter, sans-serif',
                fontSize: 'clamp(12px, 1.2vw, 14px)',
                color: '#000000',
                lineHeight: '1.4'
              }}>
                {member.role}
                {member.italicSubline && (
                  <div style={{ fontStyle: 'italic', marginTop: '2px' }}>
                    {member.sublineLink ? (
                      <a
                        href={member.sublineLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: '#000000', textDecoration: 'underline' }}
                      >
                        {member.italicSubline}
                      </a>
                    ) : (
                      member.italicSubline
                    )}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>

      </div>
      </div>
    </section>
  );
};

const BoardBubble = () => {
  // 1. Grid Logic:
  // Card width is pinned to Core Team's 4-column math (100% minus 3 gaps,
  // divided by 4) rather than to however many advisors currently exist, so
  // photo size always matches Core Team's regardless of board headcount.
  // Flexbox (not CSS Grid) is what lets a partial, under-full row of
  // fixed-width cards center itself instead of stretching to fill it.
  const css = `
    .board-grid {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      gap: 30px; /* Space between photos */
      width: 100%;
    }
    .board-grid > * {
      flex: 0 0 calc((100% - 90px) / 4);
      max-width: calc((100% - 90px) / 4);
    }

    /* The Breakpoint: Below 800px width, force 2 columns (matches Core Team's) */
    @media (max-width: 800px) {
      .board-grid > * {
        flex-basis: calc((100% - 30px) / 2);
        max-width: calc((100% - 30px) / 2);
      }
    }
  `;

  const renderBoardGrid = (members) => (
    <div className="board-grid">
      {members.map((member, index) => (

        /* Individual Team Card */
        <div key={index} style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start', // Left align text like the image
          textAlign: 'left'
        }}>

          {/* Photo */}
          <img
            src={member.img}
            alt={member.name}
            style={{
              width: '100%',
              aspectRatio: '1 / 1', // Keeps images perfectly square
              objectFit: 'cover',
              borderRadius: '20px', // Matches the curve in your example
              marginBottom: '10px',
              backgroundColor: '#ccc',
              boxShadow: '0 12px 6px rgba(0,0,0,0.1)',
              border: '4px solid #0056b3', // Adjust thickness (4px) and color (#0056b3) as you like
              boxSizing: 'border-box',      // Keeps the image size from expanding
            }}
          />

          {/* Name */}
          <a
            href={member.linkedin}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              fontFamily: 'Inter, sans-serif',
              fontWeight: 'bold',
              fontSize: 'clamp(14px, 1.5vw, 16px)',
              color: '#000000',
              marginBottom: '4px',
              textDecoration: 'underline',
              cursor: 'pointer'
            }}
          >
            {member.name}
          </a>

          {/* Role */}
          <div style={{
            fontFamily: 'Inter, sans-serif',
            fontSize: 'clamp(12px, 1.2vw, 14px)',
            color: '#000000',
            lineHeight: '1.4'
          }}>
            {member.role}
            {member.org && (
              <div>
                {member.orgLink ? (
                  <a
                    href={member.orgLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: '#000000', textDecoration: 'underline' }}
                  >
                    {member.org}
                  </a>
                ) : (
                  member.org
                )}
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );

  return (
    <section style={{
      backgroundColor: '#D1DEE6',
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      padding: '40px 0'
    }}>
      {/* Inject CSS for the Grid */}
      <style>{css}</style>

      {/* Shared page column so this panel's edges line up with the Header
          nav bar and every other section on the site. */}
      <div data-layout={PAGE_CONTAINER_MARK} style={{ width: '100%', maxWidth: PAGE_MAX_WIDTH, margin: '0 auto', padding: '0 5%', boxSizing: 'border-box' }}>
      {/* The Lighter Blue Bubble (#B3CFDB) */}
      <div style={{
        backgroundColor: '#B3CFDB', // Lighter blue as requested
        borderRadius: '30px',
        padding: 'clamp(20px, 4vw, 50px)',
        width: '100%',
        boxSizing: 'border-box',
        boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }}>

        {/* Title */}
        <h2 style={{
          fontFamily: 'Inter, sans-serif',
          fontSize: 'clamp(32px, 4vw, 42px)',
          marginBottom: '40px',
          marginTop: '0',
          color: '#000000',
          fontWeight: '400'
        }}>
          Advisory Board
        </h2>

        {renderBoardGrid(ADVISORY_BOARD_MEMBERS)}

      </div>
      </div>
    </section>
  );
};
const AboutUs = ({ loggedInUser, setLoggedInUser }) => {
  console.log("AboutUs Page loggedInUser:", loggedInUser ? loggedInUser.name : "No user logged in");
  return (
    <div className="min-h-screen" style={{ backgroundColor: '#D1DEE6' }}>
      <Header
        loggedInUser={loggedInUser}
        setLoggedInUser={setLoggedInUser}
        topText=""
        midText="Vicktoria"
        botText="Meet the team behind the vision" //Updated to match the new content and vibe of the page
      />
      <BubbleSection />
      <TeamBubble />
      <BoardBubble />
      <ViewportTracker />
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
      <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Judson:wght@400;700&display=swap" rel="stylesheet" />
    </div>
  );
}

export default AboutUs;